import AdminDataTable from "../../core/DataTable/DataTable";

export function ZahraSongsList () {
    return <AdminDataTable collection="songs" columns={[
        {
            name: "ID",
            field: "id",
            type: "text",
            edit: false,
        },
        {
            name: "Title",
            field: "title",
            type: "text"
        },
        {
            name: "Cover",
            field: "cover",
            type: "image",
        },
        {
            name: "Audio",
            field: "audio",
            type: "file",
            show: false
        },
        {
            name: "Created At",
            field: "createdAt",
            type: "datetime",
            edit: false,
        },
        {
            name: "Updated At",
            field: "updatedAt",
            type: "datetime",
            edit: false,
        },
    ]} />
}
